import type { CallCenterV3Types } from "@EspaceParkQC/sdk-services-legacy";

export default function UnknownParty({
  unknownPartyDetails,
}: {
  unknownPartyDetails: CallCenterV3Types.CallPartyUnknown | undefined;
}): React.ReactElement | null {
  if (!unknownPartyDetails) return null;

  return (
    <div className="w-full h-full flex justify-center items-center">
      <h1 className="text-lg font-bold">Unknown Party</h1>
    </div>
  );
}
